export function formatToDDMMYYYY(input: string | number | Date): string {
  const date = new Date(input);

  if (isNaN(date.getTime())) {
    return "Fecha inválida";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Los meses empiezan en 0
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

export const buildQueryParams = (
  args: Record<string, any>
): URLSearchParams => {
  const params = new URLSearchParams();
  Object.entries(args).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.set(key, value.toString());
    }
  });
  return params;
};
